export interface Advisor {
  name: string
  title: string
  titleEs: string
  subtitle: string
  initials: string
  gradient: string
  borderColor: string
  accentColor: string
  bio: string
  photo?: string
  link?: string
  linkedin?: string
  confirmed?: boolean
}

export const advisors: Advisor[] = [
  {
    name: 'Shin Fujiyama',
    title: 'Founder',
    titleEs: 'Rol',
    subtitle: '1,000 Schools Honduras',
    initials: 'SF',
    gradient: 'from-haa-midblue to-haa-blue',
    borderColor: 'border-haa-midblue',
    accentColor: 'text-haa-midblue',
    bio: "Shin Fujiyama is a Japanese-American philanthropist and the co-founder/executive director of Students Helping Honduras, a nonprofit focused on expanding access to education. After first volunteering in Honduras as a college student, he committed his life to building schools and supporting communities across the country through the One Thousand Schools vision. Known for turning endurance challenges into fundraising campaigns, he has completed long-distance runs to raise money for new school construction and reconstruction. Through his on-the-ground work and storytelling, he's become one of the most recognizable advocates for Honduran children's education.",
    photo:
      'https://cdn.magicpatterns.com/uploads/mzbFQ9Y86aQqjBcb8T57QY/SFujiyama.jpg',
    link: 'https://onethousandschools.com/about-us/',
    linkedin: 'https://www.linkedin.com/in/shinfujiyama/',
    confirmed: true,
  },
  {
    name: 'Bryan Girón',
    title: 'Chef & Owner',
    titleEs: 'Chef y Propietario',
    subtitle: 'Perquín · Food Network Chopped Champion',
    initials: 'BG',
    gradient: 'from-haa-blue to-haa-navy',
    borderColor: 'border-haa-blue',
    accentColor: 'text-haa-blue',
    bio: "Bryan Girón is a Honduran-born chef known for blending the bold flavors of Central America with Mediterranean and global influences. Born in Tegucigalpa, Honduras, and raised in New Jersey, Girón discovered his passion for cooking through his grandmother, whose recipes and market traditions continue to inspire his cuisine today. After studying at Johnson & Wales University, he built an impressive culinary résumé working in acclaimed kitchens including Shukette, Barbuto, Bread + Salt, Beauty & Essex, and The Stanton Social. He is the chef and owner of Perquín in Jersey City, where he showcases modern Honduran cuisine through thoughtfully crafted dishes rooted in heritage, travel, and live-fire cooking. In 2026, Girón gained national recognition after becoming the first Honduran-born chef to win Food Network's Chopped.",
    photo:
      'https://cdn.magicpatterns.com/uploads/1mwQgrFyjXzjzbD83Pj3Hh/ALF_Selects_MaxFlatow-24.jpg',
    link: 'https://perquinjc.com/#about',
    confirmed: true,
  },
  {
    name: 'Mayra Pineda',
    title: 'President & CEO',
    titleEs: 'Presidenta y CEO',
    subtitle: 'Hispanic Chamber of Commerce of Louisiana',
    initials: 'MP',
    gradient: 'from-haa-blue to-haa-midblue',
    borderColor: 'border-haa-blue',
    accentColor: 'text-haa-blue',
    bio: 'Born in Tegucigalpa, Honduras, Mayra Pineda holds a Bachelor of Arts in Business Administration from the Académie des Langues et de Commerce in Geneva, Switzerland. She is a distinguished business leader who serves as President & CEO of the Hispanic Chamber of Commerce of Louisiana. Throughout her career, she has demonstrated a steadfast commitment to fostering strong and enduring business relationships among Louisiana, the Hispanic community, and Latin America. She previously served as Consul General of Honduras, with jurisdiction over New Orleans, Arkansas, Tennessee, Mississippi, and Alabama.',
    photo:
      'https://cdn.magicpatterns.com/uploads/2dzVjN99euSDTp5cscg6Dg/MPineda.png',
    link: 'https://hispanicchamberla.com/our-team/mayra-pineda/',
    confirmed: true,
  },
  {
    name: 'Diana Brown',
    title: 'School Board Member',
    titleEs: 'Rol',
    subtitle: 'Manassas City Public Schools',
    initials: 'DB',
    gradient: 'from-haa-skyblue to-haa-midblue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: "Diana Brown serves on the Manassas City School Board, where she is a visible advocate for strong public schools, inclusive learning environments, and student-centered decision-making. She was elected in 2025 to a four-year term, and she is also the Vice-Chair of Northern Virginia Community College's College Board. An immigrant from Honduras and an award-winning educator, Brown brings deep experience in special education leadership and has been recognized statewide for her work supporting students and teachers.",
    photo:
      'https://cdn.magicpatterns.com/uploads/sPxY4Xb8DhQbk1RWGgqTiC/Diana_Brown_Profile.png',
    link: 'https://www.nvcc.edu/about/leadership/college-board/members/brown.html',
    linkedin: 'https://www.linkedin.com/in/diana-brown-291107a8/',
    confirmed: true,
  },
  {
    name: 'Jose Quiroz',
    title: 'Sheriff',
    titleEs: 'Rol',
    subtitle: "Arlington County Sheriff's Office",
    initials: 'JQ',
    gradient: 'from-haa-navy to-blue-950',
    borderColor: 'border-haa-navy',
    accentColor: 'text-haa-navy',
    bio: "Jose Quiroz serves as Sheriff of Arlington County, Virginia, leading the Sheriff's Office in its responsibilities for jail operations, courthouse security, and community-facing public safety services. He joined the Arlington County Sheriff's Office on September 10, 2001, and rose through the ranks before taking office as Sheriff in January 2023. He is Arlington's first Latino Sheriff, and his parents are immigrants from Honduras, a background he often cites as central to his commitment to service and community trust.",
    photo:
      'https://cdn.magicpatterns.com/uploads/6fUv9Rs178QH3yuvotmBNL/Jose_Quiroz_Profile.png',
    link: 'https://www.arlingtonva.us/Government/County-Leadership/Executive-Bios/Jose-Quiroz',
    confirmed: true,
  },
  {
    name: 'Martha Hernandez',
    title: 'Majority Owner & President',
    titleEs: 'Propietaria Mayoritaria y Presidenta',
    subtitle: 'Extreme Wood Works · Founder, Amor y Fuerza',
    initials: 'MH',
    gradient: 'from-haa-skyblue to-haa-blue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: 'Martha Hernandez is a dynamic force in both the business and philanthropic worlds. As Majority Owner and President of Extreme Wood Works of South Florida, Inc., she has built a career defined by passion, perseverance, and purpose. Originally from Honduras, she assumed leadership of the family business at just 20 years old while balancing life as a young mother and college student. In 2020, following the devastation of Hurricanes Eta and Iota, she led the shipment of five humanitarian aid containers to Honduras and Nicaragua—an effort that gave rise to Amor y Fuerza, a nonprofit that continues to uplift vulnerable communities in Miami and internationally. Dedicated to service and social impact, Martha leads with innovation, compassion, and an uplifting energy that inspires those around her.',
    photo:
      'https://cdn.magicpatterns.com/uploads/5Xg2AVjhqQShfqNvqfpS3S/Martha_wht_outfit_2026.png',
    link: 'https://extremewoodworks.com/',
    confirmed: true,
  },
]
